<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="course" class="container py-3">
    <h1 class="lifedi-color text-center mb-5">ข้อความส่วนตัว</h1>

    <mat-card *ngIf="chatUser.length === 0 " class="row mt-4 mb-3" style=" background: #f0f0f0;">
        <h3 class="col-12 text-center" style="margin: 16px 0; color: #ccc;">ยังไม่มีการสนทนา</h3>
    </mat-card>

    <div *ngIf="chatUser.length > 0" class="row">
        <div class="col-4">
            <mat-card class="chat-box">
                <h5 class="text-center">คอร์ส: {{ course[0].COURSE_NAME }}</h5>

                <mat-card *ngFor="let u of chatUser" class="p-3 mb-2 user-box"
                    [ngClass]="u.ACTIVE ? 'user-active' : 'user-inactive'" (click)="selectUser(u)">
                    <div class="row d-flex">
                        <div class="col-9">
                            <p class="text-left">Username: {{ u.USERNAME }}</p>
                            <p [ngClass]="u.COUNT_UNREAD === 0 ? 'read' : 'lifedi-color'" class="text-left cut-text">
                                <!-- <span *ngIf="u.COUNT_UNREAD > 0 && u.LAST_MESSAGE === ''"> -->
                                <span *ngIf="u.LAST_MESSAGE === ''">
                                    ไฟล์แนบ
                                </span>
                                <span *ngIf="u.LAST_MESSAGE !== ''">
                                    {{ u.LAST_MESSAGE }}
                                </span>
                            </p>
                        </div>
                        <div class="col-3 d-flex justify-content-center">
                            <span *ngIf="u.COUNT_UNREAD > 0" [matBadge]="u.COUNT_UNREAD >= 99 ? '99+' : u.COUNT_UNREAD"
                                matBadgeOverlap="false"></span>
                            <!-- <span *ngIf="u.COUNT_UNREAD > 0" class="text-center dot">
                                <p style="margin-top: 5px; color: #fff;">
                                    <span *ngIf="u.COUNT_UNREAD > 99">99+</span>
                                    <span *ngIf="u.COUNT_UNREAD < 99">{{ u.COUNT_UNREAD }}</span>
                                </p>
                            </span> -->
                        </div>
                    </div>
                </mat-card>
            </mat-card>
        </div>
        <div class="col-8">
            <div class="container">
                <div *ngIf="privateMessage.length === 0 " class="row">
                    <mat-card class="blank-box align-items-center d-flex justify-content-center">
                        <h1 class="text-center">
                            เริ่มการสนทนา
                        </h1>
                    </mat-card>
                </div>
                <div *ngIf="privateMessage.length > 0">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="text-right text-secondary">
                                Username: {{ username }}
                            </h4>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-12">

                            <div class="chatroom-container" #chatroom>
                                <div *ngFor="let c of privateMessage">
                                    <div [ngClass]="c.USER_TYPE === 'admin' ? 'chat-right' : 'chat-left'">
                                        <div *ngIf="c.USER_TYPE === 'admin'" class="chat-hour text-right">
                                            {{ c.CREATE_DATE | dateTime:'time' }} น.<br>
                                            {{ c.CREATE_DATE | dateTime:'shortNoTime' }}
                                        </div>
                                        <div class="chat-text-left"
                                            [ngClass]="c.USER_TYPE === 'admin' ? 'chat-text-right' : 'chat-text-left'">
                                            <div *ngIf="c.MESSAGE_TYPE === 'text'">
                                                {{ c.MESSAGE }}
                                            </div>
                                            <div *ngIf="c.MESSAGE_TYPE === 'image'">
                                                <img nz-image class="image-attach" [nzSrc]="c.MESSAGE" alt="" />
                                            </div>
                                            <div *ngIf="c.MESSAGE_TYPE === 'file'">
                                                <a (click)="downloadFile(c.MESSAGE)" class="text-center attach-file">
                                                    {{c.FILE_NAME}}
                                                    <img src="assets/attachment.png" alt="attach" style="width: 10px;">
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="c.USER_TYPE === 'user'" class="chat-hour">
                                            {{ c.CREATE_DATE | dateTime:'time' }} น.<br>
                                            {{ c.CREATE_DATE | dateTime:'shortNoTime' }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-2">
                            <nz-upload nzListType="picture-card"
                                nzAccept=".png, .jpg, .jpeg, .pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                [(nzFileList)]="fileList" [nzShowButton]="fileList.length < 5"
                                [nzCustomRequest]="successRequest" (nzChange)="handleChange($event, privateChatForm)"
                                [nzPreview]="handlePreview">
                                <!-- (nzChange)="compressFile($event)" [nzPreview]="handlePreview"> -->
                                <div>
                                    <i nz-icon nzType="plus"></i>
                                    <div style="margin-top: 8px">
                                        <p>ลากไฟล์หรือคลิกเพื่ออัปโหลดไฟล์</p>
                                        <p class="text-danger">สูงสุด 5 ไฟล์</p>
                                    </div>
                                </div>
                            </nz-upload>
                            <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                                (nzOnCancel)="previewVisible = false">
                                <ng-template #modalContent>
                                    <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
                                </ng-template>
                            </nz-modal>
                        </div>
                        <div class="col-12">
                            <form [formGroup]="privateChatForm">
                                <textarea formControlName="message" class="form-control" id="object" rows="3"
                                    style="width: 100%;" (ngModelChange)="getStatusSending($event)"></textarea>
                            </form>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <lifedi-btn *ngIf="sendTextStatus || sendImageStatus" lable="ส่ง"
                            (click)="sendPrivateChat(privateChatForm)" style="margin: 0 auto;"
                            customStyle="background-color: #3E8C1A; color: #FFF; margin: 15px; padding: 0 30px;">
                        </lifedi-btn>
                        <lifedi-btn *ngIf="!sendTextStatus && !sendImageStatus" disabled="true" lable="ส่ง"
                            style="margin: 0 auto;" customStyle="margin: 15px; padding: 0 30px;">
                        </lifedi-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>